
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consulta/rapida/[type]",
      function () {
        return require("private-next-pages/consulta/rapida/[type].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/consulta/rapida/[type]"])
      });
    }
  